import React from "react";
import Drawer from "@material-ui/core/Drawer";
import NavigationList from "./NavigationList";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";
import { Link } from "react-router-dom";

const drawerWidth = "150px";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    paper: {
      overflowX: "hidden",
      backgroundColor: theme.palette.secondary.main,
    },
    logo: {
      width: drawerWidth,
      padding: "10% 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // backgroundColor: "#fff",
    },
  })
);

interface IProps {
  pathname: string;
}

const DesktopNavigator: React.FC<IProps> = ({ pathname }: IProps) => {
  const classes = useStyles();

  return (
    <Drawer className={classes.drawer} classes={{ paper: classes.paper }} variant={"permanent"} anchor={"left"}>
      <Link to={"/"} className={classes.logo}>
        <img src={`${process.env.PUBLIC_URL}/img/rcs.png`} style={{ width: "90%" }} alt={"logo-obiektu"} />
      </Link>
      <NavigationList pathname={pathname} width={drawerWidth} />
    </Drawer>
  );
};

export default DesktopNavigator;
